/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class CampaignSelectTemplateDialog extends NoboxEntityDialog<CampaignTemplateRow, any> {
        protected getFormKey() { return CampaignSelectTemplateForm.formKey; }
        protected getIdProperty() { return CampaignTemplateRow.idProperty; }
        protected getLocalTextPrefix() { return CampaignTemplateRow.localTextPrefix; }
        protected getService() { return CampaignTemplateService.baseUrl; }
        protected getDeletePermission() { return CampaignTemplateRow.deletePermission; }
        protected getInsertPermission() { return CampaignTemplateRow.insertPermission; }
        protected getUpdatePermission() { return CampaignTemplateRow.updatePermission; }

        protected form = new CampaignSelectTemplateForm(this.idPrefix);
        public setTemplate = (campaign: CampaignTemplateRow) => {};

        private btnMessageCount: number = 0;
        private btnActionCount: number = 0;
        constructor(container?: JQuery) {
            super(container);
            this.form.ChannelId.change(() => {
                if (!Q.isEmptyOrNull(this.form.ChannelId.text)) {
                    this.form.ChannelNm.value = this.form.ChannelId.text;
                }
            });



            this.form.BodyType.change(() => {
                var val = this.form.BodyType.get_value();
                if (!Q.isEmptyOrNull(val)) {
                    if (val == "0") {
                        this.form.BodyHtml.getGridField().toggle(false);
                        this.form.BodyText.getGridField().toggle(true);
                        Serenity.EditorUtils.setRequired(this.form.BodyHtml, false);
                        Serenity.EditorUtils.setRequired(this.form.BodyText, true);
                    } else if (val == "1") {
                        this.form.BodyHtml.getGridField().toggle(true);
                        this.form.BodyText.getGridField().toggle(false);
                        Serenity.EditorUtils.setRequired(this.form.BodyHtml, true);
                        Serenity.EditorUtils.setRequired(this.form.BodyText, false);
                    }
                }
            });
            this.form.Template.change(() => {
                var val = this.form.Template.get_value();
                if (!Q.isEmptyOrNull(val)) {
                    var item = this.form.Template.selectedItem as CampaignTemplateRow;
                    Serenity.EditorUtils.setValue(this.form.Name, item.Name);
                    Serenity.EditorUtils.setValue(this.form.ChannelId, item.ChannelId);
                    Serenity.EditorUtils.setValue(this.form.ChannelNm, item.ChannelNm);
                    Serenity.EditorUtils.setValue(this.form.Subject, item.Subject);
                    Serenity.EditorUtils.setValue(this.form.Body, item.Body);
                    Serenity.EditorUtils.setValue(this.form.BodyType, item.BodyType);
                    Serenity.EditorUtils.setValue(this.form.Attachment, item.Attachment);
                    if (item.BodyType == BodyType.BodyTypeEnum.Text) {
                        this.form.BodyHtml.getGridField().toggle(false);
                        this.form.BodyText.getGridField().toggle(true);
                        this.form.BodyText.value = item.Body;

                        this.buttonMessage(1, false);
                        this.buttonMessage(2, false);
                        this.buttonMessage(3, false);

                        this.buttonAction(1, false);
                        this.buttonAction(2, false);
                    } else if (item.BodyType == BodyType.BodyTypeEnum.HTML) {
                        this.form.BodyHtml.getGridField().toggle(true);
                        this.form.BodyText.getGridField().toggle(false);
                        this.form.BodyHtml.set_value(item.Body);

                        this.buttonMessage(1, false);
                        this.buttonMessage(2, false);
                        this.buttonMessage(3, false);

                        this.buttonAction(1, false);
                        this.buttonAction(2, false);
                    }

                    if (item.BodyType == BodyType.BodyTypeEnum.QuickReply) {
                        this.form.InteractiveMsg.value = item.InteractiveMsg;
                        this.setButtonMessage(item.InteractiveMsg);

                        for (var i = 1; i <= 3; i++) {
                            if (i <= this.btnMessageCount) {
                                this.buttonMessage(i, true);
                            } else {
                                this.buttonMessage(i, false);
                            }
                        }
                    }

                    if (item.BodyType == BodyType.BodyTypeEnum.CallToAction) {
                        this.form.InteractiveMsg.value = item.InteractiveMsg;
                        this.setButtonAction(item.InteractiveMsg);
                        for (var i = 1; i <= 2; i++) {
                            if (i <= this.btnActionCount) {
                                this.buttonAction(i, true);
                            } else {
                                this.buttonAction(i, false);
                            }
                        }
                    }
                } else {
                    Serenity.EditorUtils.setValue(this.form.Name, null);
                    Serenity.EditorUtils.setValue(this.form.ChannelId, null);
                    Serenity.EditorUtils.setValue(this.form.ChannelNm, null);
                    Serenity.EditorUtils.setValue(this.form.Subject, null);
                    Serenity.EditorUtils.setValue(this.form.Body, null);
                    Serenity.EditorUtils.setValue(this.form.BodyType, 0);
                    Serenity.EditorUtils.setValue(this.form.Attachment, null);
                    this.form.BodyText.value = "";
                    this.form.BodyHtml.set_value(null);
                }
            });
            var initFile = false;
            this.form.Attachment.element.parent().find("ul").on("DOMNodeInserted", function () {
                if (initFile == false) {
                    initFile = true;
                    $('ul li.file-item.file-image').each(function () {
                        var elIMage = $(this).find(".thumb ");
                        $(this).find(".thumb ").removeAttr("style");
                        $(this).find(".thumb ").css("overflow", "hidden");
                        var image = elIMage.attr("href");
                        elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                    });
                    initFile = false;
                }
            });
        }

        setButtonMessage(json) {
            var button = JSON.parse(json) as [{
                buttonId: string,
                buttonText: {
                    displayText: string,
                }
                type: number
            }];
            this.btnMessageCount = button.length;
            button.forEach((x, i) => {
                this.form[`Button${i == 0 ? "" : i}`].value = x.buttonText.displayText;
            });
        }

        setButtonAction(json) {
            var button = JSON.parse(json) as [];
            this.btnActionCount = button.length;
            button.forEach((x, i) => {
                var text = this.form[`ButtonAct${i == 0 ? "" : i}Text`];
                var value = this.form[`ButtonAct${i == 0 ? "" : i}`];
                var type = this.form[`ButtonAct${i == 0 ? "" : i}Type`];
                if (x["callButton"] != undefined) {
                    Serenity.EditorUtils.setValue(type, "call");
                    text.value = x["callButton"]["displayText"];
                    value.value = x["callButton"]["phoneNumber"];
                } else if (x["urlButton"] != undefined) {
                    Serenity.EditorUtils.setValue(type, "url");
                    text.value = x["urlButton"]["displayText"];
                    value.value = x["urlButton"]["url"];
                }
            });
        }

        buttonMessage(number: number, hidden: boolean) {
            if (hidden) {

                this.form.ButtonAct.getGridField().toggle(false);
                this.form.ButtonActText.getGridField().toggle(false);
                this.form.ButtonActType.getGridField().toggle(false);
                Serenity.EditorUtils.setRequired(this.form.ButtonActType, false);
                Serenity.EditorUtils.setRequired(this.form.ButtonActText, false);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct, false);

                this.form.ButtonAct1.getGridField().toggle(false);
                this.form.ButtonAct1Text.getGridField().toggle(false);
                this.form.ButtonAct1Type.getGridField().toggle(false);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1Type, false);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1Text, false);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1, false);
            }
            if (number == 1) {
                //this.btnMessageCount = hidden ? 1 : 0;

                this.form.Button.getGridField().toggle(hidden);
                this.form.ButtonCloseHide.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.Button, hidden);
            } else if (number == 2) {
                this.form.Button1.getGridField().toggle(hidden);
                this.form.Button1CloseHide.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.Button1, hidden);
            } else if (number == 3) {

                this.form.Button2.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.Button2, hidden);
            }
        }

        buttonAction(number: number, hidden: boolean) {
            if (hidden) {
                this.form.Button.getGridField().toggle(false);

                this.form.Button1.getGridField().toggle(false);

                this.form.Button2.getGridField().toggle(false);

                Serenity.EditorUtils.setRequired(this.form.Button, false);
                Serenity.EditorUtils.setRequired(this.form.Button1, false);
                Serenity.EditorUtils.setRequired(this.form.Button2, false);
            }
            if (number == 1) {
                //this.btnActionCount = hidden ? 1 : 0;

                this.form.ButtonAct.getGridField().toggle(hidden);
                this.form.ButtonActText.getGridField().toggle(hidden);
                this.form.ButtonActType.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonActType, hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonActText, hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct, hidden);
            } else if (number == 2) {

                this.form.ButtonAct1.getGridField().toggle(hidden);
                this.form.ButtonAct1Text.getGridField().toggle(hidden);
                this.form.ButtonAct1Type.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1Type, hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1Text, hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1, hidden);
            }
        }

        protected updateInterface() {
            super.updateInterface();
            var item = this.get_entity();
            if (this.isEditMode()) {
                if (item.BodyType == 0) {
                    this.form.BodyHtml.getGridField().toggle(false);
                    this.form.BodyText.getGridField().toggle(true);
                    this.form.BodyText.value = item.Body;
                    Serenity.EditorUtils.setRequired(this.form.BodyText, true);
                } else if (item.BodyType == 1) {
                    this.form.BodyHtml.getGridField().toggle(true);
                    this.form.BodyText.getGridField().toggle(false);
                    this.form.BodyHtml.set_value(item.Body);
                    Serenity.EditorUtils.setRequired(this.form.BodyHtml, true);
                    Serenity.EditorUtils.setRequired(this.form.BodyText, false);
                }
            }
        }

        protected getDialogTitle() {
            return "Select Template";
        }

        protected getToolbarButtons() {
            var buttons = [] as Serenity.ToolButton[];
            buttons.push({
                title: "Apply Template",
                icon: "fa-check text-blue",
                onClick: () => {
                    if (this.validateForm()) {
                        this.setTemplate(this.getSaveEntity());
                        Q.notifySuccess("Success Apply Template " + this.form.Template.selectedItem.Name);
                        this.dialogClose();
                    }
                }
            });
            return buttons;
        }
    }
}